/**
 * The app is served under a path on rentrisk.com (https://rentrisk.com/app),
 * so a root-relative path like "/storage/x.png" would leave the app for the
 * marketing site. The server renders the app's own root URL into
 * <meta name="app-url"> (url('/'), which includes the forwarded /app prefix);
 * appUrl() puts it in front of a path. Without the tag (tests, older pages)
 * paths are returned unchanged.
 */
export const appBase = () => {
    if (typeof document === 'undefined') {
        return ''
    }

    return (document.querySelector('meta[name="app-url"]')?.getAttribute('content') ?? '').replace(/\/+$/, '')
}

export const appUrl = (path = '/') => appBase() + (path.startsWith('/') ? path : `/${path}`)
